export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_FAILURE = 'FETCH_FAILURE';
export const FETCH_AWARD_WINNING_CREATIVE_SUCCESS = 'FETCH_AWARD_WINNING_CREATIVE_SUCCESS';
export const HIDE_LOADER = 'HIDE_LOADER';
